import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GameType } from '@src/lib/types';
import { LobbyState } from '@src/state/slices/types';

const initialState: LobbyState = {
  pendingGameAsHost: null,
  gameTypes: ['regular', 'wager'],
};

export const lobbySlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    onCreatedGameId: (
      state,
      action: PayloadAction<{ gameId: string; playerId: string }>,
    ) => {
      state.pendingGameAsHost = {
        gameId: action.payload.gameId,
        playerId: action.payload.playerId,
      };
    },
    onSelectGameTypes: (state, action: PayloadAction<GameType[]>) => {
      state.gameTypes = action.payload;
    },
  },
});

export default lobbySlice.reducer;

export const { onCreatedGameId, onSelectGameTypes } = lobbySlice.actions;
